import React, { Component,Fragment} from 'react';
import logo from './logo.svg';
import axios from 'axios';

import { HashRouter , Router, Route, Link,Routes } from "react-router-dom";
import Login from './Login/Login';
// import 'bootstrap/dist/css/bootstrap.min.css';
import Forgotpassword from './Login/ForgotPassword';
import CreateNewUser from './Login/CreateNewUser';
import Home from './Home/Home';
import Savings from './Savings/SavingHome';
import FixedDeposit from './FixedDeposits/FDHome';
import SavingsDetails from './Savings/MakePayments/SavingsDetails';
import Pawning from './Pawning/Pawning';
import ProtectedRoute from './Middleware/Auth';
import './Assets/css/custom.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import Layout from './Common/layout';
import Test from './Common/test';

function App() {
  return (
    <div>
      < HashRouter  >
        <Routes>
          <Route exact path='/ForgotPassword' element={<Forgotpassword />} />
          <Route exact path='/UserRegister' element={<CreateNewUser />} />
            <Route element={<ProtectedRoute />}>
                  <Route exact path='/Home' element={<Home />} />
                  <Route exact path='/Savings' element={<Savings />} />
                  <Route exact path='/FixedDeposit' element={<FixedDeposit />} />
                  <Route exact path='/SavingsDetails' element={<SavingsDetails />} />
                  <Route exact path='/Pawning' element={<Pawning />} />
            </Route>
          <Route exact path='/' element={<Login />} />
          <Route exact path='/test' element={<Test />} />
        </Routes>
      </ HashRouter>
  </div>
  );
}

export default App;
